import { baseURLWSocket } from '../config/config'
import { updateViews } from './webSocketMethods'
import { WEBSOCKET_TYPES } from './Constants'
import { PostsServices } from '../../database/posts.database'

// Small helper to generate a lightweight request id when `uuid` isn't available
const generateRequestId = () => `req_${Math.random().toString(36).slice(2, 9)}_${Date.now().toString(36)}`
// class WebSocketSingleton {

//     static instance = null;
//     static ws = null;
//     static reconnectAttempts = 0;
//     static listeners = [];
//     // static isConnecting = false;

//     static  getInstance(apiUrlWSocket) {
//         if ((!this.instance || Object.keys(this.instance).length == 0) && apiUrlWSocket) {
//             this.instance = new WebSocketSingleton();
//             this.connect(apiUrlWSocket);
//         }
//         return WebSocketSingleton.instance;
//     }

//     constructor() {
//         if (!WebSocketSingleton.instance) {
//             this.ws = null;
//             WebSocketSingleton.instance = this;
//         }
//         return WebSocketSingleton.instance;
//     }
//     static connect(apiUrlWSocket) {
//         if (!apiUrlWSocket) return;

//         // WebSocketSingleton.isConnecting = true;
//         if (this.ws == null) {
//             this.ws = new WebSocket(apiUrlWSocket);
//

//             this.ws.addEventListener('open', () => {
//
//

//                 this.reconnectAttempts = 0;
//                 // WebSocketSingleton.isConnecting = false;
//                 this.notifyListeners('open');
//             });

//             this.ws.addEventListener('message', async (event) => {
//
//                 const data = JSON.parse(event.data);
//                 await handleMessage(data);
//                 this.notifyListeners('message', data);
//             });

//             this.ws.addEventListener('error', (error) => {
//                 console.error('Error en la conexión del WebSocket:', error);
//                 // WebSocketSingleton.isConnecting = false;
//                 this.reconnect(apiUrlWSocket);
//                 this.notifyListeners('error', error);
//             });

//             this.ws.addEventListener('close', () => {
//
//                 // WebSocketSingleton.isConnecting = false;
//                 this.reconnect(apiUrlWSocket);
//                 this.notifyListeners('close');
//             });
//         }
//     }

//     static reconnect(apiUrlWSocket) {
//
//         const delay = Math.min(3000 + this.reconnectAttempts * 5000, 30000); // max delay of 30 seconds

//         setTimeout(() => {
//             this.reconnectAttempts++;
//             this.connect(apiUrlWSocket);
//         }, delay);
//     }

//     static notifyListeners(eventType, data) {
//         this.listeners.forEach(listener => {
//             if (listener.event === eventType) {
//                 listener.callback(data);
//             }
//         });
//     }

//     addListener(event, callback) {
//         this.listeners.push({ event, callback });
//     }

//     removeListener(event, callback) {
//         const index = this.listeners.findIndex(listener => listener.event === event && listener.callback === callback);
//         if (index !== -1) {
//             this.listeners.splice(index, 1);
//         }
//     }

//     sendMessage(data, type, token) {
//         const dataToSend = data.filter(item => item["_id"] != null);
//         const result = {
//             type: type,
//             data: dataToSend,
//             token: token
//         };

//         return new Promise((resolve, reject) => {
//

//             if (this.ws && this.ws.readyState === WebSocket.OPEN) {
//                 try {
//                     this.ws.send(JSON.stringify(result));
//
//                     resolve(); // Resuelve la promesa aquí
//                 } catch (error) {
//                     console.error("Error al enviar los datos", error);
//                     reject(error);
//                 }
//             } else {
//                 console.error("WebSocket no está abierto, intentando reconectar...");
//             }
//         });
//     }
// }

// export default WebSocketSingleton;

// /**
//  * @description Genera la URL de WebSocket del usuario
//  * @param {*} nameGroup
//  * @param {*} user_id
//  * @param {*} device
//  * @returns {string} URL de conexión
//  */
export const generateWebSocketUrl = (nameGroup, user_id, device) => {
    const urlParams = new URLSearchParams({
        name_group: nameGroup,
        user: user_id,
        device: device,
    })

    console.log('🔧 [WebSocketContext] Setting up WebSocket')

    const wsUrl = `${baseURLWSocket}?${urlParams.toString()}`

    return wsUrl
}

class WebSocketSingleton {
    constructor(apiUrlWSocket) {
        if (!WebSocketSingleton.instance) {
            this.url = apiUrlWSocket
            this.socket = null
            this.isConnected = false
            this.eventListeners = {}
            this._connectTs = Date.now()
            // Map to keep requestId -> original payload for correlation with server errors
            this._pendingRequests = new Map()

            // How long to keep pending request entries (ms)
            this._pendingRequestTtl = 1000 * 60 * 5 // 5 minutes
            WebSocketSingleton.instance = this
            this.initWebSocket()
        }
        return WebSocketSingleton.instance
    }

    initWebSocket() {
        try {
            this.socket = new WebSocket(this.url)

            this.socket.onopen = () => {
                this.isConnected = true
                this.dispatchEvent('open')
            }

            this.socket.onmessage = async (message) => {
                try {
                    console.log('🔴 [WS] onmessage FIRED at', new Date().toISOString())

                    const raw = message?.data
                    let data = null
                    try {
                        data = typeof raw === 'string' ? JSON.parse(raw) : raw
                    } catch (e) {
                        console.error('[WS] onmessage JSON.parse error for data:', raw, e)
                    }

                    const type = data?.type || 'message'
                    console.log('🟢 [WS] onmessage TYPE:', type)

                    // Common server payload fields useful for correlation
                    const serverMsg = data?.message || null
                    const serverReqId = data?.requestId || data?.meta?.requestId || null
                    const serverConnectionId = data?.connectionId || data?.meta?.connectionId || null

                    // If the server returns an error message, try to correlate with sent request
                    if (serverMsg) {
                        console.log('[WS][recv] serverMessage:', serverMsg)
                    }

                    if (serverReqId && this._pendingRequests.has(serverReqId)) {
                        const original = this._pendingRequests.get(serverReqId)
                        console.warn('[WS][recv] Correlated server response to sent requestId:', serverReqId, { originalPayloadPreview: original.preview, originalFull: original.payload, serverData: data })
                        // Optionally remove immediately to free memory
                        this._pendingRequests.delete(serverReqId)
                    } else if (serverReqId) {
                        console.log('[WS][recv] received requestId not found locally:', serverReqId)

                        // Heuristic: try to match server response to recent pending requests
                        try {
                            const now = Date.now()
                            const candidates = []
                            for (const [k, v] of this._pendingRequests.entries()) {
                                const age = Math.abs(now - (v.sentAt || 0))
                                if (age < 10000) { // within 10 seconds
                                    // prefer same type if available
                                    const sameType = (v.payload && v.payload.type) === (data && data.type)
                                    candidates.push({ requestId: k, age, sameType, preview: v.preview })
                                }
                            }
                            candidates.sort((a, b) => {
                                if (a.sameType && !b.sameType) return -1
                                if (!a.sameType && b.sameType) return 1
                                return a.age - b.age
                            })
                            if (candidates.length) {
                                console.warn('[WS][recv] Potential matching pendingRequests for server requestId:', serverReqId, 'candidates:', candidates.slice(0,3))
                            }
                        } catch (e) {
                            // ignore heuristic failures
                        }
                    }

                    if (serverConnectionId) console.log('[WS][recv] connectionId:', serverConnectionId)
                    // Log acotado
                    // if (type === 'POSTS_VIEWEDS') {
                    //     console.log('[WS][recv][POSTS_VIEWEDS] count=', (data?.posts || []).length)
                    // } else {
                    //     console.log('[WS][recv]', type)
                    // }
                    // ✅ Log detallado para POSTS_VIEWEDS
                    if (type === 'POSTS_VIEWEDS') {
                        console.log('[WS][recv][POSTS_VIEWEDS] Full data:', {
                            count: (data?.posts || []).length,
                            posts: data?.posts?.slice(0, 3), // Primeros 3 posts para ver estructura
                            timestamp: new Date().toISOString(),
                        })
                    } else {
                        console.log('[WS][recv]', type)
                    }
                    this.dispatchEvent(type, message.data)
                } catch (e) {
                    console.warn('[WS] onmessage parse error', e?.message)
                }
            }

            this.socket.onclose = () => {
                this.isConnected = false
                this.dispatchEvent('close')
                setTimeout(() => {
                    console.log('[WS] reconnecting...')
                    this.initWebSocket()
                }, 5000)
            }

            this.socket.onerror = (errorEvent) => {
                // errorEvent is usually an Event; try to capture useful info
                console.error('[WS] socket.onerror fired:', errorEvent)
                try {
                    // Some browsers expose a `.message` or `.error` property
                    if (errorEvent?.message) console.error('[WS] socket.onerror message:', errorEvent.message)
                } catch (ignore) {}
                this.dispatchEvent('error', errorEvent)
            }
        } catch (error) {
            console.error('[WS] init error:', error?.message || error)
        }
    }

    // Update the URL and force a reconnect (close existing socket and re-init)
    updateUrlAndReconnect(newUrl) {
        if (!newUrl) return
        try {
            console.log('[WS] updateUrlAndReconnect:', newUrl)
            // Close existing socket gracefully
            if (this.socket) {
                try {
                    this.socket.onopen = null
                    this.socket.onmessage = null
                    this.socket.onclose = null
                    this.socket.onerror = null
                } catch (ignore) {}
                try { this.socket.close() } catch (ignore) {}
                this.socket = null
            }
            this.url = newUrl
            this._connectTs = Date.now()
            // Reinitialize
            this.initWebSocket()
        } catch (e) {
            console.error('[WS] updateUrlAndReconnect error:', e)
        }
    }

    // Close socket and clear instance internal state (used on logout)
    disconnect() {
        try {
            console.log('[WS] disconnecting socket')
            if (this.socket) {
                try {
                    this.socket.onopen = null
                    this.socket.onmessage = null
                    this.socket.onclose = null
                    this.socket.onerror = null
                } catch (ignore) {}
                try { this.socket.close() } catch (ignore) {}
                this.socket = null
            }
            this.isConnected = false
            // clear pending requests
            try { this._pendingRequests.clear() } catch (ignore) {}
        } catch (e) {
            console.error('[WS] disconnect error:', e)
        }
    }

    send(data, type, token) {
        return new Promise((resolve, reject) => {
            console.log('📤 [WS] ATTEMPTING TO SEND')

            if (this.socket && this.socket.readyState === this.socket.OPEN) {
                const dataToSend = data.filter((item) => item['_id'] != null)
                // Attach a requestId and metadata to help server/client correlation
                const requestId = generateRequestId()
                const meta = { requestId, clientTs: new Date().toISOString() }
                const result = {
                    type: type,
                    data: dataToSend,
                    token: token,
                    // include both `requestId` at top-level and inside `meta` so backends
                    // that expect either location can echo it back for correlation
                    requestId,
                    clientRequestId: requestId,
                    meta,
                }

                // Keep a copy for correlation if server returns an error mentioning requestId
                try {
                    const payloadStr = JSON.stringify(result)
                    const preview = payloadStr.length > 1000 ? payloadStr.slice(0, 1000) + '...[truncated]' : payloadStr
                    this._pendingRequests.set(requestId, { payload: result, preview, sentAt: Date.now() })

                    // Auto-cleanup pendingRequests after ttl
                    setTimeout(() => {
                        if (this._pendingRequests.has(requestId)) this._pendingRequests.delete(requestId)
                    }, this._pendingRequestTtl)

                    console.log('📦 [WS] MESSAGE PAYLOAD preview:', preview)

                    this.socket.send(payloadStr)
                    console.log('✅ [WS] Message SENT successfully requestId=', requestId)
                    resolve({ ok: true, requestId })
                } catch (e) {
                    console.error('❌ [WS] Send FAILED:', e)
                    // remove pending entry on failure
                    try { this._pendingRequests.delete(requestId) } catch (ignore) {}
                    return reject(e)
                }
            } else {
                const rs = this.socket ? this.socket.readyState : -1
                // console.warn('[WS][send] not connected, readyState=', rs)

                console.warn('⚠️ [WS] Cannot send - Not connected')
                console.warn('ReadyState:', rs)
                reject('WebSocket is not connected')
            }
        })
    }

    getReadyState() {
        return this.socket ? this.socket.readyState : -1
    }

    addEventListener(event, listener) {
        if (!this.eventListeners[event]) {
            this.eventListeners[event] = []
        }
        this.eventListeners[event].push(listener)
    }

    removeEventListener(event, listener) {
        if (this.eventListeners[event]) {
            this.eventListeners[event] = this.eventListeners[event].filter((l) => l !== listener)
        }
    }

    dispatchEvent(event, data) {
        if (this.eventListeners[event]) {
            this.eventListeners[event].forEach((listener) => listener(data))
        }
    }
}

// Function to initialize the singleton instance with WebSocket URL
async function initializeWebSocketInstance(apiUrlSocket) {
    if (!apiUrlSocket) return
    if (WebSocketSingleton.instance) {
        // If instance exists, update URL and reconnect if different
        try {
            if (WebSocketSingleton.instance.url !== apiUrlSocket) {
                WebSocketSingleton.instance.updateUrlAndReconnect(apiUrlSocket)
            }
        } catch (e) {
            console.error('[WS] initializeWebSocketInstance update error:', e)
        }
        return WebSocketSingleton.instance
    }

    const webSocketInstance = new WebSocketSingleton(apiUrlSocket)
    return webSocketInstance
}

export default initializeWebSocketInstance

export async function reconnectWebSocket(apiUrlSocket) {
    if (!apiUrlSocket) return
    if (WebSocketSingleton.instance) {
        WebSocketSingleton.instance.updateUrlAndReconnect(apiUrlSocket)
        return WebSocketSingleton.instance
    }
    return await initializeWebSocketInstance(apiUrlSocket)
}

export function disconnectWebSocket() {
    if (WebSocketSingleton.instance) {
        try {
            WebSocketSingleton.instance.disconnect()
            return true
        } catch (e) {
            console.error('[WS] disconnectWebSocket error:', e)
            return false
        }
    }
    return false
}

const handleMessage = async (data) => {
    try {
        switch (data.type) {
            case WEBSOCKET_TYPES.POSTS_VIEWEDS:
                await updateViews(data.posts)
                break
            case WEBSOCKET_TYPES.BENEFIT:
                break
            case WEBSOCKET_TYPES.BENEFIT_REDEEM:
                break
            default:
                break
        }
    } catch (error) {
        console.error('Error:', error)
    }
}
